import { Actor } from '../actor/Actor';
export class QuestionPart extends Actor {
    type = 'questionpart';
}
